import { Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const { Title } = Typography;

function EmissionCard({ title, value, lastYear }) {
  // Calculate percentage change
  const percentageChange = ((value - lastYear) / lastYear) * 100;
  const isIncrease = percentageChange > 0;

  return (
    <div className="relative bg-white shadow-lg rounded-lg p-4 w-[500px] h-[150px] flex flex-col justify-between">
      {/* Info Icon in Top Right */}
      <InfoCircleOutlined className="absolute top-2 right-2 text-gray-400 text-lg" />
      
      {/* Title */}
      <Title level={4} className="text-gray-700 mb-1 font-bold">
        {title}
      </Title>

      {/* Value */}
      <p className="text-xl font-bold text-gray-800">
        <span className="text-5xl">{value}</span> tonnes CO₂
      </p>

      {/* Previous Year Comparison */}
     
      <p className="text-sm text-gray-500">
        Previous: {lastYear} tonnes CO₂{" "}
        <span className={`font-semibold ${isIncrease ? "text-green-600" : "text-red-600"}`}>
          ({isIncrease ? "+" : ""}
          {percentageChange.toFixed(1)}%)
        </span>
      </p>

    </div>
  );
}

export default EmissionCard;
